import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setStep, BOOKING_STEP } from '../../actions/Booking';
import { requestPasswordReset } from '../../actions/Session';

import '../../static/less/user_login.less';

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      backToLogin: false,
      resetResult: '',
    };
    this.passwordReset = this.passwordReset.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setStep(BOOKING_STEP.NO_AVAIL_STEP));
  }

  updateEmail(ev) {
    this.setState({ username: ev.target.value });
  }

  passwordReset() {
    this.setState({ backToLogin: false, resetResult: '' });
    this.props.dispatch(requestPasswordReset(this.state.username)).then(({ success }) => {
      let msg;
      if (success) {
        msg = this.context.t('Please check your email inbox with the link to reset your password');
      } else {
        msg = this.context.t('Sorry, your username could not be verified');
      }
      this.setState({ backToLogin: success, resetResult: msg });
    });
  }

  renderLoggedIn() {
    return (
      <div className="PasswordReset container">
        <div className="row">
          {this.context.t('You are already logged in')}
        </div>
      </div>
    );
  }

  renderLoginButton() {
    if (!this.state.backToLogin) {
      return null;
    }
    return (
      <a className="btn btn-primary login-button" href="/callcenter/login/">
        {this.context.t('Back to login')}
      </a>
    );
  }

  render() {
    if (!this.props.user.isAnonymous) {
      this.renderLoggedIn();
    }
    return (
      <section className="LoginForm">
        <h1>{this.context.t('Enter your username or email')}</h1>
        <p>{this.context.t('If a user matches, an email will be sent that will allow you to reset your password')}</p>
        <div className="form-group">
          <label htmlFor="reset-password">{this.context.t('Email / Username')}:</label>
          <input id="login-username" className="form-control" type="text" value={this.state.username}
                 onChange={this.updateUsername} />
        </div>
        <button className="btn btn-primary reset-button" onClick={this.passwordReset}
          disabled={this.state.backToLogin}>
          {this.context.t('Reset password')}
        </button>
        {this.renderLoginButton()}
        <div className={`reset-result reset-result--${this.state.backToLogin ? 'success' : 'error'}`}>
          {this.state.resetResult}
        </div>
      </section>
    );
  }
}

PasswordReset.contextTypes = {
  router: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  user: state.session.user || { isAnonymous: true },
}))(PasswordReset);
